import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import PurchaseServices from '../../services/PurchaseServices';

function AddPurchase() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    itemName: '',
    billNumber: '',
    amount: '',
    image: '',
    vendorName: '',
    vendorContact: '',
    description: '',
    vendorAddress: '',
    date: '',                  
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      
      setFormValues({
        ...formValues,
        image: file, 
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
     
    const formData = new FormData();
    formData.append('itemName', formValues.itemName);
    formData.append('billNumber', formValues.billNumber);
    formData.append('amount', formValues.amount);
    formData.append('image', formValues.image); 
    formData.append('vendorName', formValues.vendorName);
    formData.append('vendorContact', formValues.vendorContact);
    formData.append('vendorAddress', formValues.vendorAddress);
    formData.append('description', formValues.description);
    formData.append('date', formValues.date);

      await PurchaseServices.addPurchase(formData);
      alert('Item created successfully');
      navigate('/purchase');
    } catch (error) {
      console.error('Failed to create Item', error);
      alert('Failed to create Item');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
          <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
        
                  <div className="my-auto">
        
                    <h5 className="page-title fs-21 mb-1">
                    Item Add
                      </h5>
                    <nav>
        
                      <ol className="breadcrumb mb-0">
        
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">Home</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                        Item
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
        
        
                  <Link className="list-banner-btn" to="/purchase">Purchase Item List</Link>

                  
        
                  </div>
                </div>
       

        <div className="container-box">
          
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Item Name<span className="red">*</span></label>
                      <input type="text" name="itemName" value={formValues.itemName}
                        onChange={handleInputChange} className="form-control" required placeholder='Enter Item Name' />
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Amount<span className="red">*</span></label>
                      <input type="number" name="amount" value={formValues.amount}
                        onChange={handleInputChange} className="form-control" required placeholder='Enter Amount' />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Date<span className="red">*</span></label>
                      <input type="date" name="date" value={formValues.date}
                        onChange={handleInputChange} className="form-control" required />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Item Bill Number<span className="red">*</span></label>
                      <input type="text" name="billNumber" value={formValues.billNumber}
                        onChange={handleInputChange} className="form-control" required placeholder='Enter Item Bill Number' />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Slip Upload<span className="red">*</span></label>
                      <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                      <p><span>Drop an image or Paste URL (Max 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                    </div>
                  </div>

                  <duv className='col-md-4'>
                  <div className="file-preview text-center">
                        <img id="uploadFile" src={previewImage} alt="Uploaded Preview" />
                      </div>
                  </duv>

                  <h3 className="mt-4">Vendor Details</h3>
                  <div className='col-md-6'>
                    <div className="input-field">
                      <label>Vendor Name<span className="red">*</span></label>
                      <input type="text" name="vendorName" value={formValues.vendorName}
                        onChange={handleInputChange} className="form-control" required placeholder="Enter Vendor Name" />
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className="input-field">
                      <label>Vendor Contact<span className="red">*</span></label>
                      <input type="text" name="vendorContact" value={formValues.vendorContact}
                        onChange={handleInputChange} className="form-control" required placeholder="Enter Vendor Contact" />
                    </div>
                  </div>
                  <div className="input-field">
                    <label>Vendor Address<span className="red">*</span></label>
                    <textarea name="address" value={formValues.address}
                      onChange={handleInputChange} className="form-control h-auto" required placeholder="Enter Vendor Address"></textarea>
                  </div>

                  <button className="submit-green-btn">SUBMIT</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddPurchase;
